import { ReqCfg, Options } from './types/api'
import type Transform from './types/transform'
import { getMethod, getMethodName, replaceParams } from './replace'

export const transform = function <T>(UrlMap: T, options: Options = {}): Transform<T> {
    // @ts-ignore
    return Object.entries(UrlMap).reduce((acc, [key, value]) => {
        acc[key] = (data?: any, requestConfig?: ReqCfg) => {
            // @ts-ignore
            const reqStr = isFunction(value) ? value() : value
            const requestMethod = getMethod(reqStr, options)
            const requestMethodName = getMethodName(reqStr)

            const initReqCfg: ReqCfg = {
                domain: '',
                intercept: false,
                removeParams: requestMethodName === 'get'
            }

            const config = Object.assign(initReqCfg, requestConfig)

            if (Array.isArray(data)) {
                const url = replaceParams(reqStr, {}, config, options)
                return requestMethod(url, data, config, options)
            } else {
                const requestData = { ...data }
                const url = replaceParams(reqStr, requestData, config, options)
                return requestMethod(url, requestData, config, options)
            }
        }
        return acc
    }, {} as Transform<T>)
}